import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getMapDatasetsQuery, getMapQuery } from '../api/mapQueries'
import { useAppSelector } from 'app/state'
import { deleteMap } from '../api/maps'
import { tagsQueryKey } from 'features/tags/api/tagsQueries'
export function useMapWithDatasets(
  mapId: string | undefined,
  { allowCurrentMap = true }: { allowCurrentMap: boolean }
) {
  const currentMap = useAppSelector((state) => state.maps.currentMap)
  const currentMapDatasets = useAppSelector((state) => state.maps.currentMapDatasets)

  if (mapId === undefined && currentMap && allowCurrentMap) {
    mapId = currentMap?.id
  }
  const useCurrentMap = allowCurrentMap && currentMap && currentMap.id === mapId
  const mapQuery = useQuery({ ...getMapQuery(mapId), enabled: Boolean(mapId) && !useCurrentMap })
  const datasetsQuery = useQuery({
    ...getMapDatasetsQuery(mapId),
    enabled: Boolean(mapId) && !useCurrentMap
  })

  const isLoading = useCurrentMap ? false : mapQuery.isLoading || datasetsQuery.isLoading

  return {
    map: useCurrentMap ? currentMap : mapQuery.data,
    datasets: useCurrentMap ? currentMapDatasets : datasetsQuery.data,
    isLoading
  }
}

export function useDeleteMap() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteMap,
    onSuccess: () => {
      queryClient.invalidateQueries(tagsQueryKey.get, { exact: false })
    }
  })
}

export function useMapDatasets(mapId: string | undefined, { allowCurrentMap = true }: { allowCurrentMap?: boolean }) {
  const currentMapId = useAppSelector((state) => state.maps.currentMap?.id)
  const currentMapDatasets = useAppSelector((state) => state.maps.currentMapDatasets)

  if (mapId === undefined && currentMapId && allowCurrentMap) {
    mapId = currentMapId
  }
  const useCurrentMap = allowCurrentMap && currentMapId === mapId

  const datasetsQuery = useQuery({
    ...getMapDatasetsQuery(mapId),
    enabled: Boolean(mapId) && !useCurrentMap
  })

  if (useCurrentMap) {
    return { data: currentMapDatasets, isLoading: false }
  }
  return datasetsQuery
}
